/**
 * 瓦斯行對照表：由 URL 的 `supplier` 參數決定當前瓦斯行。
 * 目前為寫死示範資料，之後接後端時改以 supplier id 向 API 查詢即可。
 */
export interface Supplier {
  name: string;
  phone: string;
  area: string;
  /** 完整營業地址（來自後端 supplier-by-shop-code）。後端沒回就留空，前端整列不顯示，
   *  絕不填 demo 地址頂替 —— 顯示錯的瓦斯行地址比不顯示更糟。 */
  address?: string;
  /** 真實後端 supplier_id（由 shopCode → GET /register/supplier-by-shop-code 解析出時才有值）。
   *  demo fallback 沒有真實 id，維持 undefined。 */
  supplier_id?: string;
}

export const SUPPLIERS: Record<string, Supplier> = {
  S001: { name: "幸福瓦斯行", phone: "04-2345-6789", area: "台中市西屯區" },
  S002: { name: "永盛瓦斯行", phone: "04-2777-1234", area: "台中市南屯區" },
  S003: { name: "大安瓦斯行", phone: "02-2701-5678", area: "台北市大安區" },
};

/** 查不到 id 時的 fallback（維持既有 demo 行為） */
export const DEFAULT_SUPPLIER: Supplier = SUPPLIERS.S001;

export const getSupplier = (id?: string | null): Supplier =>
  (id && SUPPLIERS[id]) || DEFAULT_SUPPLIER;
